// 2026-10-23：按机构读取网页展示配置；会员价格和功能授权仍由原业务接口决定。
import { computed, ref, watch } from 'vue'
import store from '@/store'
import request from '@/utils/request'
import { translateUi } from '@/i18n/display'
import schema from '../../../ldservice/src/main/resources/client-page-settings-schema.json'

type PageValue = string | number | boolean
const defaults: Record<string, PageValue> = {}
for (const group of schema.groups) for (const field of group.fields) defaults[field.key] = field.default
const values = ref<Record<string, PageValue>>({})
const loadedOrg = ref(0)
const ready = ref(false)
let sequence = 0

// 独立于页面的共享监听避免同一导航/首页重复请求；切店先清空旧店覆盖。
watch(() => Number(store.getters.orgId), async orgId => {
  const current = ++sequence
  values.value = {}
  loadedOrg.value = orgId
  ready.value = false
  if (!Number.isSafeInteger(orgId) || orgId <= 0) return
  try {
    const response: any = await request({ url: 'land/clientPageSettings', method: 'GET', params: { orgId, _pageTs: Date.now() } })
    if (current === sequence && Number(response.data?.orgId) === orgId && response.data?.values) values.value = response.data.values
  } catch (_error) {
    // 尚未部署展示接口或网络不可用时，沿用随版本交付的原页面内容。
  } finally {
    if (current === sequence) ready.value = true
  }
}, { immediate: true })

export function useClientPageSettings() {
  const pageValue = (key: string, fallback?: PageValue): PageValue => {
    const configured = values.value[key]
    return configured !== undefined ? configured : defaults[key] !== undefined ? defaults[key] : fallback !== undefined ? fallback : ''
  }
  const pageText = (key: string, params: Record<string, unknown> = {}) => String(translateUi(pageValue(key))).replace(/\{([A-Za-z][A-Za-z0-9_]*)\}/g,
    (match, name) => Object.prototype.hasOwnProperty.call(params, name) ? String(params[name] ?? '') : match)
  const pageImage = (key: string, fallbackAsset = '') => {
    const image = String(pageValue(key) || '').trim()
    if (!image) return fallbackAsset
    if (/^https?:\/\//i.test(image) || /^\/(?!\/)/.test(image)) return image
    const host = String(store.getters.ossHost || '').replace(/\/$/, '')
    return host ? host + '/' + image.replace(/^\/+/, '') : image
  }
  const pageLink = (key: string, fallback: string) => {
    const link = String(pageValue(key, fallback)).trim()
    const safe = (value: string) => /^\/main(?:\/|$|[?#])/.test(value) && !/[\\\s]/.test(value) && !Array.from(value).some(character => character.charCodeAt(0) < 32) && !value.includes('..')
    return safe(link) ? link : safe(fallback) ? fallback : '/main/index'
  }
  const settingsReady = computed(() => ready.value && loadedOrg.value === Number(store.getters.orgId))
  const hasPageSetting = (key: string) => Object.prototype.hasOwnProperty.call(values.value, key)
  return { pageValue, pageText, pageImage, pageLink, hasPageSetting, settingsReady, pageStyle: computed(() => ({})) }
}
